import Section from "../Section/Section";
import Skills from "../../common/Skills";
import { SiGithub, SiLinkedin } from "react-icons/si";
import { BiSolidEnvelope, BiMapPin } from "react-icons/bi";
import SectionTitle from "../../common/SectionTitle";

export default function About() {
  return (
    <Section id="about" className="pt-8">
      <SectionTitle>Sobre mí</SectionTitle>
      <div className="flex md:flex-row flex-col gap-10 items-start">
        {/* Profile column */}
        <div className="relative flex w-full flex-col items-center gap-4 md:min-w-48 md:w-48">
          <div className="relative">
            <div className="absolute inset-0 rounded-full bg-green-300/20 blur-xl scale-110" />
            <img
              src="img/profile.webp"
              alt="Franco Martino"
              className="relative rounded-full w-40 h-40 object-cover shadow-xl shadow-black/40 ring-2 ring-green-300/30"
            />
          </div>
          {/* Social links under photo */}
          <div className="flex gap-3 text-gray-400">
            <a
              href="https://github.com/FrancoMartino/"
              target="_blank"
              rel="noreferrer"
              className="hover:text-white transition-colors duration-200 p-1.5 rounded-lg hover:bg-gray-800"
            >
              <SiGithub size={18} />
            </a>
            <a
              href="https://www.linkedin.com/in/francomartino/"
              target="_blank"
              rel="noreferrer"
              className="hover:text-white transition-colors duration-200 p-1.5 rounded-lg hover:bg-gray-800"
            >
              <SiLinkedin size={18} />
            </a>
            <a
              href="mailto:martinofrancoezequiel@gmail.com"
              className="hover:text-white transition-colors duration-200 p-1.5 rounded-lg hover:bg-gray-800"
            >
              <BiSolidEnvelope size={18} />
            </a>
          </div>
          {/* Location */}
          <span className="flex items-center gap-1.5 text-xs text-gray-500">
            <BiMapPin size={13} />
            Buenos Aires, Argentina
          </span>
        </div>

        {/* Bio column */}
        <div className="flex flex-col gap-5 flex-1 text-gray-300">
          <div>
            <h3 className="text-3xl font-bold font-header text-white leading-tight">
              Franco Martino
            </h3>
            <p className="text-green-300 font-medium mt-1">
              Desarrollador de Software · Técnico Electrónico
            </p>
          </div>

          <p className="text-gray-400 leading-relaxed text-[15px]">
            Desarrollador argentino con formación en electrónica y estudios en
            Ingeniería Informática. Construyo aplicaciones web con React y
            TypeScript, herramientas de automatización con Python, y soluciones
            de electrónica e IoT con C++ y Arduino.
          </p>

          <p className="text-gray-400 leading-relaxed text-[15px]">
            Mis proyectos incluyen{" "}
            <strong>myATS</strong> (web app para CVs optimizados para ATS),
            <strong> Cod-ES</strong> (librería Arduino en español, premiada
            por educación), <strong>CENDOJ Extractor</strong> (web scraping
            para el sector legal) y <strong>Massive CF</strong> (automatización
            de marketing en Instagram).
          </p>

          <p className="text-gray-400 leading-relaxed text-[15px]">
            Me distingo por{" "}
            <span className="text-white font-medium">
              aprender rápido, adaptarme a nuevos desafíos
            </span>{" "}
            y mantener el foco en la experiencia del usuario final.
          </p>

          {/* Soft skills */}
          <Skills soft className="!justify-start" />
        </div>
      </div>
    </Section>
  );
}
